import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import Actions from '../redux/actions';
import AppLoader from '../utils/AppLoader';
import PaginationComponenent from '../component/Pagination';
import Constants, { LIMIT, THREEDSCRIPT } from '../utils/Constants';
import { toast } from 'react-toastify';
import RoutePath from '../utils/routes/RoutePath';
import VBImageList from '../component/VBImageList';

class VendorVBList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pageNumber: 1,
            totalItem: '',
            isVendor: false,
        }
    }
    componentDidMount() {
        const Agent = this.props.match.path.split('/')
        if (Agent[2] === "virtualBackground" && Agent[1] === "admin") {
            this.setState({ isVendor: true })
        } else {
            this.setState({ isVendor: false })
        }
        this.getVBImageList()
    }

    getVBImageList = () => {
        let params = {
            limit: LIMIT,
            pageNumber: 0
        }
        const callback = (response) => {
            if (response) {
                this.setState({ totalItem: response.response.totalItems })
            }
        }
        this.props.getVbImageList(params, callback, false)
    }
    onChangePagination = (pageNumber) => {
        let params = {
            pageNumber: (pageNumber - 1),
            limit: LIMIT
        }
        this.props.getVbImageList(params, '', false)
        this.setState({ pageNumber: pageNumber })
    }
    updateStatus = (id, active) => {
        const updateParams = {
            id,
            isActive: active ? 0 : 1
        }
        const callback = (response) => {
            if (response.response_code === 0) {
                toast.success(Constants.UPDATED_SUCCESSFULLY)
                this.getVBImageList()
            }
            else {
                toast.error(response.response_message)
            }
        }
        this.props.updateVbImage(updateParams, callback, false)
    }
    addProduct = () => {
        this.props.history.push(RoutePath.VENDOR_VB_ADD)
    }
    render() {
        const { pageNumber, isVendor } = this.state;
        const { getVBImage = {} } = this.props
        const { isLoading, vbImageListData } = getVBImage
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <div className='addButton'>
                            <div className="add-btn">
                                <button className="btn add-item" type="button" onClick={() => this.addProduct()}><i className="fa-solid fa-plus me-3"></i>Add Virtual Background</button>
                            </div>
                        </div>
                        <VBImageList vbImageList={vbImageListData?.vbImages} updateStatus={(id, active) => this.updateStatus(id, active)}
                            isVendor={isVendor}
                            currentPage={pageNumber} />
                        <div className='page-content'>
                            {
                                vbImageListData?.totalItems > (LIMIT - 1) ? <PaginationComponenent currentPage={pageNumber} countValue={vbImageListData?.totalItems} onChangeHandle={this.onChangePagination} /> : ''
                            }
                        </div>
                    </div>
                </div>

                {isLoading && <AppLoader />}
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        getVBImage: Actions.getVbImage(state)
    }
};
export default withRouter(connect(mapStateToProps, {
    getVbImageList: Actions.getVbImageList,
    updateVbImage: Actions.updateVbImage
})(VendorVBList
));